__turbopack_context__.v({
  "beat": "Product-module-scss-module__R30nvW__beat",
  "bestSeller-icon": "Product-module-scss-module__R30nvW__bestSeller-icon",
  "bottom-icon-dsk": "Product-module-scss-module__R30nvW__bottom-icon-dsk",
  "button-3d": "Product-module-scss-module__R30nvW__button-3d",
  "card": "Product-module-scss-module__R30nvW__card",
  "image-wrapper": "Product-module-scss-module__R30nvW__image-wrapper",
  "login-overlay": "Product-module-scss-module__R30nvW__login-overlay",
  "login-overlay-btn": "Product-module-scss-module__R30nvW__login-overlay-btn",
  "login-overlay-wrapper": "Product-module-scss-module__R30nvW__login-overlay-wrapper",
  "sale": "Product-module-scss-module__R30nvW__sale",
  "text": "Product-module-scss-module__R30nvW__text",
  "view-in-room-mobile": "Product-module-scss-module__R30nvW__view-in-room-mobile",
});
